import React from 'react';
import classNames from 'classnames';
import cls from './ModalBodyTasksMonth.module.css';
import { useModalBodyTasksMonth } from './useModalBodyTasksMonth';
import { ModalTaskElement } from './UI/ModalTaskElement/ModalTaskElement';

interface ModalBodyTasksMonthProps {
    classes?: string;
}

export const ModalBodyTasksMonth = ({ classes }: ModalBodyTasksMonthProps) => {
    const {} = useModalBodyTasksMonth();
    return (
        <div className={classNames(cls.ModalBodyTasksMonth, [classes])}>
            <ModalTaskElement />
            <ModalTaskElement />
            <ModalTaskElement />
        </div>
    );
};
